import {
  CAlert,
  CButton,
  CCloseButton,
  CCol,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  COffcanvasTitle,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CLoadingButton,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import GradeService from 'src/service/GradeService'
import ToastComponent from 'src/components/common/TaostComponent'
import GradeTeams from './GradeTeams'

const EditForm = ({ gradeId, visible, onClose, fetchUsers }) => {
  const [gradeDetail, setGradeDetail] = useState()
  const [errorMessages, setErrorMessages] = useState([])
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    if (visible && gradeId) {
      GradeService.getGradeDetail(gradeId).then((res) => {
        if (res.status === 200) {
          setGradeDetail(res.data)
        }
      })
    }
  }, [visible, gradeId])

  const validationSchema = Yup.object().shape({
    grade: Yup.string().required('Comp Name is required').max(50, '50 Character Limit is allowed.'),
  })

  const formik = useFormik({
    initialValues: {
      grade: gradeDetail?.grade,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data) => {
      setLoader(true)
      GradeService.editGrade({ ...data, gradeId })
        .then((res) => {
          if (res.status === 200) {
            setErrorMessages([])
            fetchUsers()
            ToastComponent(res.message, 'success')
            onClose()
          } else {
            const errors =
              res.errors && Array.isArray(res.errors)
                ? res.errors
                : [res.message || 'Something went wrong.']
            setErrorMessages(errors)
          }
          setLoader(false)
        })
        .catch(() => {
          ToastComponent('Something went wrong. Please try again.', 'error')
          setLoader(false)
        })
    },
  })

  const handleClose = () => {
    setErrorMessages([])
    onClose()
  }

  return (
    <COffcanvas
      placement="end"
      visible={visible}
      onHide={handleClose}
      backdrop
      style={{ width: 520 }}
    >
      <COffcanvasHeader>
        <div>
          <COffcanvasTitle>
            Edit Comp
            {gradeDetail?.sn && (
              <span className="text-medium-emphasis small fw-normal ms-2">{gradeDetail.sn}</span>
            )}
          </COffcanvasTitle>
          <div className="text-medium-emphasis small">
            Update the competition name and manage its teams.
          </div>
        </div>
        <CCloseButton className="text-reset" onClick={handleClose} />
      </COffcanvasHeader>
      <COffcanvasBody className="d-flex flex-column">
        {errorMessages.length > 0 && (
          <div className="error-list">
            {errorMessages.map((error, index) => (
              <CAlert color="danger" key={index}>
                {error}
              </CAlert>
            ))}
          </div>
        )}
        <CForm className="row g-3" onSubmit={formik.handleSubmit}>
          <CCol xs={12}>
            <h6 className="fw-bold mb-0">Comp Details</h6>
          </CCol>
          <CCol xs={12}>
            <CFormLabel htmlFor="grade">Comp Name *</CFormLabel>
            <CFormInput
              placeholder="Comp Name"
              className={
                'form-control' + (formik.errors.grade && formik.touched.grade ? ' is-invalid' : '')
              }
              value={formik.values.grade || ''}
              onChange={formik.handleChange}
              aria-label="grade"
              id="grade"
            />
            {formik.errors.grade && formik.touched.grade && (
              <CFormFeedback invalid>{formik.errors.grade}</CFormFeedback>
            )}
          </CCol>
        </CForm>
        <GradeTeams gradeId={gradeId} visible={visible} onTeamsChanged={fetchUsers} />
      </COffcanvasBody>
      <div className="d-flex justify-content-between gap-2 p-3 border-top">
        <CButton color="secondary" variant="outline" onClick={handleClose}>
          Cancel
        </CButton>
        <CLoadingButton color="primary" loading={loader} onClick={() => formik.handleSubmit()}>
          Save Changes
        </CLoadingButton>
      </div>
    </COffcanvas>
  )
}

export default EditForm
